export default __webpack_public_path__ + "static/media/transport.47c6bdb0.svg";